module.exports = __webpack_public_path__ + "static/img/t21.9182e5f4.png";